import { createContext, useContext } from 'react';

export const KioskContext = createContext(false);
export const useKiosk = () => useContext(KioskContext);
